import successIcon from "../../assests/page/succes-icon.svg";
import errorIcon from "../../assests/page/error-icon.svg";
import { useNavigate } from "react-router-dom";

const SuccessPopup = (props) => {
  const navigate = useNavigate();

  const timeoutId = setTimeout(() => {
    props.setPopupContentPosition("flex-end");

    if (props.nextPopup) {
      props.setPopupContent(props.nextPopup);
      if (props.setFavouriteClicked) {
        props.setFavouriteClicked(true);
      }

      props.setShowPopup(true);
    } else if (!props.isError) {
      props.setShowPopup(false);
      props.setPopupContentPosition("center");
      props.setPopupContent(null);
      if (props.setFavouriteClicked) {
        props.setFavouriteClicked(false);
      }
      navigate("/");
    } else if (props.isError) {
      props.setShowCustomPopup(false);
      props.setCustomPopupPosition("center");
      props.setCustomPopupContent(null);
    }
  }, Number(props.timeout) || 5000);

  return (
    <>
      {!props.isCustom && (
        <div
          style={
            props.mobileScreen
              ? {
                  alignContent: "center",
                  justifyContent: "center",
                  width: "100%",
                }
              : {
                  alignContent: "center",
                  justifyContent: "center",
                }
          }
          className="success-popup-content-container"
        >
          <div className="success-popup-content">
            <img
              src={props.isError ? errorIcon : successIcon}
              alt="Success Icon"
            />
            <div className="success-popup-content-text">
              <p className="success-popup-content-text-header">
                {props.isError ? "Favorite Error" : "Successfully saved"}
              </p>
              <p className="success-popup-content-text-footer">
                {props.productClicked.name} has been added to “
                {props.whitelistName}”
              </p>
            </div>
          </div>
        </div>
      )}
      {props.isCustom && (
        <div
          style={
            props.mobileScreen
              ? {
                  alignContent: "center",
                  justifyContent: "center",
                  position: "relative",
                  height: "100%",
                  width: "100%",
                }
              : props.customWidth
              ? { width: `${props.customWidth}%` }
              : {
                  alignContent: "center",
                  justifyContent: "center",
                  position: "relative",
                  height: "100%",
                }
          }
          className="success-popup-content-container"
        >
          <div className="success-popup-content">
            <img
              src={props?.isError ? errorIcon : successIcon}
              alt="Success Icon"
            />
            <div className="success-popup-content-text">
              <p className="success-popup-content-text-header">
                {props.customTextHeader}
              </p>
              <p className="success-popup-content-text-footer">
                {props.customTextFooter}
              </p>
            </div>
          </div>

          {props.showButton && props.buttonText && (
            <div
              style={{
                paddingRight: "25px",
                paddingLeft: "25px",
                position: "absolute",
                bottom: "25px",
                width: "100%",
              }}
            >
              <button
                onClick={() => {
                  clearTimeout(timeoutId);
                  props.buttonFunc();
                }}
                className="startup-button-active"
              >
                <p className="add-funds-popup-a-f-button-text">
                  {props.buttonText}
                </p>
              </button>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SuccessPopup;
